export default "__VITE_ASSET__Bbn8mTd5__"